import { render, staticRenderFns } from "./commonSearchFace.vue?vue&type=template&id=349a97ea&scoped=true"
import script from "./commonSearchFace.vue?vue&type=script&lang=js"
export * from "./commonSearchFace.vue?vue&type=script&lang=js"
import style0 from "./commonSearchFace.vue?vue&type=style&index=0&id=349a97ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349a97ea",
  null
  
)

export default component.exports